"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _default = exports.default = {
  computed: {
    /**
     * @description: 判断 序号是否需要存在？
     * @return { Boolean } 序号列是否显示
     */
    isIndexShow: function isIndexShow() {
      var _this$$slots, _this$columnOptions, _this$columnOptions2, _ref, _ref2;
      var a = false;

      // 如果默认插槽中有序号这个el-table-column 的插槽，那么就不需要默认带的序号
      a = (_this$$slots = this.$slots) === null || _this$$slots === void 0 || (_this$$slots = _this$$slots.default) === null || _this$$slots === void 0 ? void 0 : _this$$slots.some(function (slot) {
        var _slot$componentOption;
        return (slot === null || slot === void 0 || (_slot$componentOption = slot.componentOptions) === null || _slot$componentOption === void 0 || (_slot$componentOption = _slot$componentOption.propsData) === null || _slot$componentOption === void 0 ? void 0 : _slot$componentOption.type) === 'index';
      });
      if (a) return false;

      //
      // console.log(this.$slots.some(slot => slot?.componentOptions?.propsData?.type === 'index'))
      // if (this.$slots?.componentOptions?.propsData?.type === 'index') return false

      a = (_this$columnOptions = this.columnOptions) === null || _this$columnOptions === void 0 ? void 0 : _this$columnOptions.showIndex;
      var b = this.$attrs.showIndex;
      var c = this.showIndex;
      var d = this.columnIndexOptions === null;
      var e = ((_this$columnOptions2 = this.columnOptions) === null || _this$columnOptions2 === void 0 ? void 0 : _this$columnOptions2.indexOptions) === null;
      if (d || e) return false;
      return (_ref = (_ref2 = a !== null && a !== void 0 ? a : b) !== null && _ref2 !== void 0 ? _ref2 : c) !== null && _ref !== void 0 ? _ref : true;
    },
    /**
     * @description: 判断 序号是否需要存在？
     * @return { Boolean } 序号列是否显示
     */
    isSelectionShow: function isSelectionShow() {
      var _this$$slots2, _this$columnOptions3, _this$table$this$$$fu, _this$columnOptions4, _ref3, _ref4;
      var a = false;

      // 如果默认插槽中有 选择 这个el-table-column 的插槽，那么就不需要默认带的序号
      a = (_this$$slots2 = this.$slots) === null || _this$$slots2 === void 0 || (_this$$slots2 = _this$$slots2.default) === null || _this$$slots2 === void 0 ? void 0 : _this$$slots2.some(function (slot) {
        var _slot$componentOption2;
        return (slot === null || slot === void 0 || (_slot$componentOption2 = slot.componentOptions) === null || _slot$componentOption2 === void 0 || (_slot$componentOption2 = _slot$componentOption2.propsData) === null || _slot$componentOption2 === void 0 ? void 0 : _slot$componentOption2.type) === 'selection';
      });
      if (a) return false;
      a = this.showSelection;
      var b = this.$attrs.showSelection;
      var c = (_this$columnOptions3 = this.columnOptions) === null || _this$columnOptions3 === void 0 ? void 0 : _this$columnOptions3.showSelection;
      var d = (_this$table$this$$$fu = this.table[this.$$fuzzySearchFieldName('chooseMode', this.table)]) !== null && _this$table$this$$$fu !== void 0 ? _this$table$this$$$fu : '';
      var e = this.columnSelectionOptions === null;
      var f = ((_this$columnOptions4 = this.columnOptions) === null || _this$columnOptions4 === void 0 ? void 0 : _this$columnOptions4.selectionOptions) === null;
      if (typeof d !== 'string' || e || f) return false;
      return (_ref3 = (_ref4 = a !== null && a !== void 0 ? a : b) !== null && _ref4 !== void 0 ? _ref4 : c) !== null && _ref3 !== void 0 ? _ref3 : true;
    },
    /** 获取 主列表数据集合
     * @return { Array } 处理 主列表数据集合
     */
    getColumns: function getColumns() {
      var _this$columns,
        _this = this,
        _this$columns2,
        _this$columns3;
      this.$$setTableColumnDefault(this.columns);
      (_this$columns = this.columns) === null || _this$columns === void 0 || _this$columns.forEach(function (column, index) {
        var _column$prop, _column$columnIndex;
        _this.$$deepMerge(column, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.columnOption.columns), _this.column));
        (_column$prop = column.prop) !== null && _column$prop !== void 0 ? _column$prop : column.prop = column.code;
        (_column$columnIndex = column.columnIndex) !== null && _column$columnIndex !== void 0 ? _column$columnIndex : column.columnIndex = index;
      });
      var a = this.columns.filter(function (v) {
        return v.show;
      });
      var b = (0, _toConsumableArray2.default)(a).pop();
      (_this$columns2 = this.columns) === null || _this$columns2 === void 0 || _this$columns2.forEach(function (column, index) {
        if (!_this.needFill && b.columnIndex === index) {
          //  && b.columnIndex === index
          if (column.width) column['min-width'] = column.width;
          if (_this.columns.map(function (c) {
            return c.width;
          }).every(function (w) {
            return !!w;
          })) delete column.width;
        }

        /* 默认列是显示的 */
        if (typeof column.show !== 'boolean') column.show = true;
      });
      return (_this$columns3 = this.columns) !== null && _this$columns3 !== void 0 ? _this$columns3 : [];
    }
  },
  methods: {
    /** 设置主数据列的 link
     * @param { Object } column 主数据列的列参数
     * @param { Object } scope 主数据 列的组件参数
     * @return { Object } 处理完的列参数
     */
    getMainColumnOptions: function getMainColumnOptions(column, scope) {
      var _ref5, _component$src, _ref6, _value$src, _component$src2, _component$src3, _a$style;
      var value = scope.row[column.prop ? column.prop : column.code];
      var a = (_ref5 = typeof column.linkOption === 'function' ? column.linkOption(value, scope) : column.linkOption) !== null && _ref5 !== void 0 ? _ref5 : {};

      /* 如果有 href 那就是链接 */
      if (this.$$isNoEmpty(column.href)) column.isLink = true;

      /* 如果是链接 */
      if (column.isLink) a.href = typeof column.href === 'function' ? column.href(value, scope) : column.href;

      /* 如果是图片 */
      if (column.isImage) {
        var _column$component, _component$style;
        (_column$component = column.component) !== null && _column$component !== void 0 ? _column$component : column.component = {};
        var component = column.component;
        component.is = 'wl-image';
        switch (this.$$dataTypeOf(value)) {
          case 'object':
            (_component$src = component.src) !== null && _component$src !== void 0 ? _component$src : component.src = (_ref6 = (_value$src = value.src) !== null && _value$src !== void 0 ? _value$src : value.url) !== null && _ref6 !== void 0 ? _ref6 : '';
            break;
          case 'array':
            (_component$src2 = component.src) !== null && _component$src2 !== void 0 ? _component$src2 : component.src = value.map(function (v) {
              var _ref7, _v$src;
              return (_ref7 = (_v$src = v.src) !== null && _v$src !== void 0 ? _v$src : v.url) !== null && _ref7 !== void 0 ? _ref7 : '';
            });
            break;
          case 'string':
            (_component$src3 = component.src) !== null && _component$src3 !== void 0 ? _component$src3 : component.src = value;
            break;
          default:
            break;
        }
        (_component$style = component.style) !== null && _component$style !== void 0 ? _component$style : component.style = {
          height: '64px'
        };
      }

      /* 设置样式 */
      (_a$style = a.style) !== null && _a$style !== void 0 ? _a$style : a.style = {
        display: 'block'
      };
      this.$$deepMerge(a.style, this.$$handleDomStyle(column.style, value, scope.row, scope.column, scope), this.$$handleDomStyle(column.setStyle, value, scope.row, scope.column, scope));
      return a;
    },
    /** 设置 主列表 组件
     * @description 根据列数据判断当前列 的内容是否是组件，如果是组件的话就设置当前列的参数
     * @param { Object } column 主数据列的列参数
     * @param { Object } scope 主数据 列的组件参数
     * @return { Object } 处理完的列 组件参数
     */
    getMainColumnComponent: function getMainColumnComponent(column, scope) {
      var _ref8, _ref9, _column$component2, _c$is;
      var value = scope.row[column.prop ? column.prop : column.code];
      var a = (_ref8 = typeof column.control === 'function' ? column.control(value, scope) : column.control) !== null && _ref8 !== void 0 ? _ref8 : {};
      var b = (_ref9 = typeof column.component === 'function' ? column.component(value, scope) : column.component) !== null && _ref9 !== void 0 ? _ref9 : {};
      (_column$component2 = column.component) !== null && _column$component2 !== void 0 ? _column$component2 : column.component = {};
      var c = this.$$deepMerge(column.component, a, b);
      delete column.control;
      c.rowIndex = scope.$index;
      (_c$is = c.is) !== null && _c$is !== void 0 ? _c$is : c.is = 'wl-control';
      this.$$deepMerge(c.style, this.$$handleDomStyle(c.style), this.$$handleDomStyle(c.setStyle));
      return (0, _objectSpread2.default)({}, c);
    },
    /** 设置 主列表 方法
     * @param { Object } column 主数据列的列参数
     * @param { Object } scope 主数据 列的组件参数
     * @return { Object } 处理完的列 组件参数
     */
    getMainColumnComponentFun: function getMainColumnComponentFun(column, scope) {
      var a = this.getMainColumnComponent(column, scope);
      var b = {};
      Object.keys(a).forEach(function (key) {
        return typeof a[key] === 'function' && (b[key] = a[key]);
      });
      return b;
    },
    /** 设置 主列表 表单条目 组件参数
     * @param { Object } column 主数据列的列参数
     * @param { Object } scope 主数据 列的组件参数
     * @return { Object } 处理完的列 组件参数
     */
    getMainColumnFormOptions: function getMainColumnFormOptions(column, scope) {
      var a = this.$$deepMerge(column.formItemOptions);
      a.is = this.isForm ? 'el-form-item' : 'div';
      if (this.isForm) {
        var _a$prop, _this$getTableFormOpt;
        (_a$prop = a.prop) !== null && _a$prop !== void 0 ? _a$prop : a.prop = "".concat((_this$getTableFormOpt = this.getTableFormOptions.formField) !== null && _this$getTableFormOpt !== void 0 ? _this$getTableFormOpt : 'data', ".").concat(scope.$index, ".").concat(column.code);
        a.style = 'margin: 0';
      }
      return a;
    }
  }
};